import { Card } from 'antd';
import './styles.css';
import { Link } from "react-router-dom";

interface PleaCardsProps {
    imageSrc: string;
    text: string;
    route: string;
    pleaId?: string;
}
export const PleaCards = ({ imageSrc, text, route, pleaId }: PleaCardsProps) => {
    console.log(pleaId);
    return (

        <Link to={route} state={pleaId} className="register-plea-card-link">
            <Card className="register-plea-card">
                <div className="d-flex flex-column align-items-center justify-content-center">
                    <img src={imageSrc} alt={text} className="register-plea-card-image" />
                    <div className="register-plea-card-text">
                        <strong className="register-plea-card-title">{text}</strong>
                    </div>
                </div>
            </Card>
        </Link>
    );
};